import { defineMessages } from 'react-intl';

export const heidi2RequestAccessModalMessages = defineMessages({
  tagline: {
    defaultMessage: 'Heidi writes, answers, and <i>now acts</i>.',
    id: 'Px6+cniqqy',
    description:
      'Tagline in the hero of the Heidi II request-access modal. i wraps the italic phrase “now acts”.',
  },
  title: {
    defaultMessage: 'Request access to Heidi II',
    id: 'nuCkz2Trnf',
    description: 'Title of the modal where a non-admin asks their admin for Heidi II',
  },
  description: {
    defaultMessage:
      'Ask your admin to get access to Heidi agents and improved memory to help handle work.',
    id: 'T4Qg9K7UYT',
    description: 'Body copy of the Heidi II request-access modal',
  },
  whatIsHeidi2: {
    defaultMessage: 'What is Heidi II?',
    id: 'zizjm49Tr8',
    description: 'Link to the Heidi II announcement from the request-access modal',
  },
  messageLabel: {
    defaultMessage: 'Message (optional)',
    id: 'v/NMZNKv6a',
    description:
      'Label of the optional message to admins in the Heidi II request-access modal',
  },
  messagePlaceholder: {
    defaultMessage: 'I’d like access to Heidi II to…',
    id: 'pzFXnbjP0n',
    description:
      'Placeholder of the optional message in the Heidi II request-access modal',
  },
  messageTooLong: {
    defaultMessage: 'Keep your message under {max, number} characters',
    id: 'xlFKFD1nEi',
    description: 'Validation error when the Heidi II access request message is too long',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: '1nrpaYre/q',
    description: 'Button closing the Heidi II request-access modal without sending',
  },
  send: {
    defaultMessage: 'Send request',
    id: 'dZXFphLdV9',
    description: 'Button sending the Heidi II access request to workspace admins',
  },
  requestSent: {
    defaultMessage: 'Request sent to your admin',
    id: 'MHXu+Yj5N2',
    description:
      'Toast shown after a Heidi II access request is sent to workspace admins',
  },
  alreadyRequested: {
    defaultMessage: 'You’ve already sent a request',
    id: 'wQgqt0iGRj',
    description: 'Toast shown when a Heidi II access request was already sent earlier',
  },
  requestError: {
    defaultMessage: 'Couldn’t send request. Try again.',
    id: 'U1nEKudJkU',
    description: 'Toast shown when sending a Heidi II access request fails',
  },
});
